import './SetStatusAlertDialog.style.less'

import {
  Button,
  Col,
  DatePicker,
  Input,
  Mentions,
  Modal,
  Row,
  Upload,
} from 'antd'
import { DeleteFilled, PaperClipOutlined } from '@ant-design/icons'

import { get } from 'lodash'
import { useMutation, useQuery } from 'react-query'
import { useState } from 'react'
import HttpRequest from '@/config/axios.config'
import moment from 'moment'
import { getUrlParams } from '@/utils/common'
import { getCollaboratorsForTasks } from '@/screens/Order/Pages/Order.transform'

interface Prop {
  visible: boolean
  onCancel: () => any
  onSubmit: () => any
  title: string
  data: any
  actualDate: any
  setActualDate: (data: any) => void
}

export function SetStatusAlertDialog(prop: Prop) {
  const { visible, onCancel, title, onSubmit, data } = prop

  const [mentions, setmentions] = useState([])

  const [comment, setcomment] = useState('')
  const [files, setfiles] = useState([])

  const { data: users } = useQuery('GET_COLLABORATOR', async () => {
    return await getCollaboratorsForTasks(getUrlParams('orderKey'))
  })

  // addCommentByTaskId
  const mutation = useMutation(
    (taskData: any) => {
      return HttpRequest.post(`/comments/tasks/${data.id}`, taskData)
    },
    {
      onSuccess: () => {},
      onError: () => {},
    }
  )

  const uploadMutation = useMutation(
    (taskData: any) => {
      return HttpRequest.post(`/medias/multiple/comments`, taskData, {
        headers: {
          [`Content-Type`]: `multipart/form-data`,
        },
      }).then((resp) => {
        return get(resp, 'data.data', [])
      })
    },
    {
      onSuccess: (data) => {
        const _payload = {
          type: 'comments',
          json_value: {
            comment: comment,
            mentions: mentions,
            medias: [],
            files: data,
          },
        }
        mutation.mutate(_payload)
        setcomment(null)
        onSubmit()
      },
      onError: () => {},
    }
  )

  const _postComment = () => {
    const formData = new FormData()
    files.map((file) => {
      formData.append('files', file)
    })
    uploadMutation.mutate(formData)
  }

  const uploadProps = {
    onRemove: (file) => {
      const index = files.indexOf(file)
      setfiles([...files, files.slice().splice(index, 1)])
    },
    maxCount: 1,
    onChange: () => {},
    beforeUpload: (file) => {
      setfiles([...files, file])
      return false
    },
    defaultFileList: [],
    showUploadList: {
      showRemoveIcon: true,
      removeIcon: <DeleteFilled />,
    },
  }

  return (
    <Modal
      className={'dialog-set-plan'}
      title={
        <div>
          <div className="dialog-header">{data.name}</div>
        </div>
      }
      width={520}
      open={visible}
      onCancel={onCancel}
      footer={[
        <Button
          key="no"
          type="primary"
          shape="round"
          className="dialog-cancel-button default-dialog-button"
          onClick={onCancel}
          block
        >
          Cancel
        </Button>,
        <Button
          key="yes"
          type="primary"
          shape="round"
          className="default-dialog-button"
          onClick={() => {
            // if (title === 'Reject' || title === 'Fail') {
            //   if (!comment) return
            // }
            _postComment()
          }}
          block
        >
          Save
        </Button>,
      ]}
    >
      <div>
        <div>
          <Row gutter={[16, 0]} align={'middle'}>
            <Col md={6} lg={6}>
              <label style={{ fontWeight: '500' }}>Status</label>
            </Col>
            <Col md={18} lg={18}>
              <div
                className="set-status-selector"
                style={{
                  minHeight: '32px !important',
                  height: '32px !important',
                }}
              >
                <Input size="large" readOnly value={title} />
              </div>
            </Col>
          </Row>
          <Row gutter={[16, 0]} align={'middle'} style={{ marginTop: 15 }}>
            <Col md={6} lg={6}>
              <label style={{ fontWeight: '500' }}>Actual Date</label>
            </Col>
            <Col md={18} lg={18}>
              <div
                className="set-status-selector"
                style={{
                  minHeight: '32px !important',
                  height: '32px !important',
                }}
              >
                <DatePicker
                  className={'br-1'}
                  autoFocus
                  style={{ width: '100%' }}
                  placeholder={'Select a date'}
                  value={prop.actualDate}
                  format="DD MMM YYYY"
                  onChange={(value: moment.Moment) => {
                    prop.setActualDate(value)
                  }}
                />
              </div>
            </Col>
          </Row>
          <div className="action-field-comment-input-container">
            <Mentions
              className={`general-brd ${title} ${
                title === 'Reject' || title === 'Fail'
                  ? !comment
                    ? 'error-border'
                    : ''
                  : ''
              }`}
              autoSize
              style={{
                background: '#ededed',
                fontSize: '18px',
                color: 'rgba(0,0,0,.85)',
              }}
              value={comment}
              onChange={(e) => setcomment(e)}
              placeholder={`Remark & Comments`}
            >
              {users?.map((user) => (
                <Mentions.Option
                  key={user?.user?.id}
                  value={`${user?.user?.first_name}`}
                  className="antd-demo-dynamic-option"
                >
                  <span
                    onClick={() => {
                      setmentions([...mentions, user?.user?.id])
                    }}
                  >
                    {user?.user?.first_name} {user?.user?.last_name}
                  </span>
                </Mentions.Option>
              ))}
            </Mentions>
            <Row className="button-container" justify={'end'}>
              <Upload {...uploadProps}>
                <Button
                  icon={<PaperClipOutlined className="icon-upload" />}
                  shape="round"
                  size="large"
                  type="text"
                />
              </Upload>
            </Row>
          </div>
          {/* <div className="ant-form-item-explain ant-form-item-explain-error">
            <div role="alert" style={{ fontWeight: 600 }}>
              {commentRequired && !comment && `Comment is Required.`}
            </div>
          </div> */}
        </div>
      </div>
    </Modal>
  )
}
